

// Default global state
export interface LoginState {
    model:{
            user:string,
            pw:string,
        }
    view:{
        loginStatus: boolean, 
        token:string,
        role: string,
    }
}

// initialise the default values
export const LoginInitialState : LoginState = {
    model:{
        user:"username",
        pw:"password",
    },
    view:{
        loginStatus: false, 
        token:"",
        role: "",
    }
}

//write a deep for all state related variables
export function deepCopyTableThingyState(toCopy:LoginState):LoginState{
    return {
        model:{
            user:toCopy.model.user,
            pw:toCopy.model.pw,
        },
        view:{
            loginStatus:toCopy.view.loginStatus,
            token:toCopy.view.token,
            role:toCopy.view.role,
        }
    }
    
}